import React from "react";
import {Close, LogoCompany, Mute} from '../iconsSvg'

export default function Header(p) {
    let chatLanguage = document.getElementById('chatLanguage');
    let lang = chatLanguage.getAttribute('data-language');

    return (
        <header className={`sm-chatHeader ${p.access ? 'with-menu' : ''}`} onClick={p.onToggleWidget}
                onMouseDown={p.onMouseDown}
                style={{backgroundColor: window.STYLE_HEADER_BACKGROUND_COLOR ? window.STYLE_HEADER_BACKGROUND_COLOR : '#005ba8'}}
        >
                <span className="header-content">
                    {window.LOGO_COMPANY_BASE64 ? <img src={`${window.LOGO_COMPANY_BASE64}`} alt="Logo"/> : LogoCompany}
                    {lang !== '' && lang === 'ua' || lang === 'uk' || lang === 'ukr' && window.LOCALE_UA_HEADER ? window.LOCALE_UA_HEADER : null}
                    {lang !== '' && lang === 'ru' || lang === 'rus' && window.LOCALE_RU_HEADER ? window.LOCALE_RU_HEADER : null}
                    {lang !== '' && lang === 'en' || lang === 'eng' && window.LOCALE_EN_HEADER ? window.LOCALE_EN_HEADER : null}
                    {lang !== '' && lang === 'uz' || lang === 'uzb' && window.LOCALE_UZ_HEADER ? window.LOCALE_UZ_HEADER : null}
                </span>
            <span className="mute">
                    <span onClick={p.handlerMuteNotification} className={p.muteNotification ? '' : 'low'}>{Mute}</span>
                    <b onClick={p.handlerHeaderCloseChat}>{Close}</b>
                </span>
        </header>
    )
}



// WEBPACK FOOTER //
// ./src/components/Header/index.js